import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"

const SEO = ({
  title,
  description,
  og_image_url,
  tags,
}) => {
  const keywords = tags ? tags.map((t) => t.tag).join(", ") : null;
  return (
    <>
      <Helmet title={title}>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {og_image_url ? (
          <meta name="image" property="og:image" content={`${process.env.GATSBY_LANDING_PAGE_URL ?? 'https://www.alooba.com'}${og_image_url}`} />
        ) : (
          ""
        )}
        {tags && (
          <meta name="keywords" content={keywords} />
        )}
      </Helmet>
    </>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  og_image_url: PropTypes.string,
  tags: PropTypes.array,
}
